import { createSlice, createSelector } from "@reduxjs/toolkit";
import {
  defaultList,
  defaultListFail,
  defaultListSuccess,
  defaultAddToDictionary,
} from "../defaultReducers";
import { defaultInitialState } from "../defaultInitialState";

export const projectOrdersSlice = createSlice({
  name: "projectOrders",
  initialState: { ...defaultInitialState },
  reducers: {
    list: defaultList,
    listSuccess: defaultListSuccess,
    listFail: defaultListFail,
    addToDictionary: defaultAddToDictionary,
    listReset: (state, action) => {
      state.listing = false;
      state.listed = false;
      state.listError = null;
    },
  },
});

export const {
  list: listProjectOrders,
  listReset: listProjectOrderReset,
} = projectOrdersSlice.actions;
export const actions = projectOrdersSlice.actions;

export const projectOrders = (state) =>
  state.projectOrders.idsList.map(
    (id) => state.projectOrders.dictionary[id]
  );

export const getProjectOrder = createSelector(
  (state) => state.projectOrders.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id];
  }
);

export const getProjectOrderAttributes = createSelector(
  (state) => state.projectOrders.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.attributes;
  }
);

export const getProjectOrderRelationships = createSelector(
  (state) => state.projectOrders.dictionary,
  (_, id) => id,
  (dictionary, id) => {
    return id && dictionary && dictionary[id]?.relationships;
  }
);

export const getProjectOrders = createSelector(
  (state) => state.projectOrders.dictionary,
  (_, ids) => ids,
  (dictionary, ids) => {
    return ids && dictionary && ids.map((id) => dictionary[id]);
  }
);

export const getProjectOrderOptions = (state) => {
  return Object.values(state.projectOrders.dictionary).map(
    (projectOrder) => ({
      value: projectOrder.id,
      label: projectOrder.attributes.name,
    })
  );
};

export default projectOrdersSlice.reducer;
